import { createRoot } from "react-dom/client";
import maplibregl from "maplibre-gl";
import { Protocol } from "pmtiles";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

const protocol = new Protocol();
maplibregl.addProtocol("pmtiles", protocol.tile);

// Apply theme immediately before render to avoid flash of wrong theme
(() => {
  const saved = localStorage.getItem("app_settings");
  const theme = saved ? JSON.parse(saved).theme : "system";
  if (theme === "dark" || (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
    document.documentElement.classList.add("dark");
  }
})();

createRoot(document.getElementById("root")!).render(<App />);
